module.exports = __webpack_public_path__ + "img/i_refresh_pr.7324fed4.svg";